<p class="text-center title-page-global" mat-dialog-title>Dữ liệu</p>
<mat-dialog-content class="mat-typography">
    {{ data.jsonData | json }}
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button class="btn btn-add" mat-dialog-close>ĐÓNG</button>
</mat-dialog-actions>